import { render, staticRenderFns } from "./ConflictManager.vue?vue&type=template&id=5545c570&scoped=true&"
import script from "./ConflictManager.vue?vue&type=script&lang=js&"
export * from "./ConflictManager.vue?vue&type=script&lang=js&"
import style0 from "./ConflictManager.vue?vue&type=style&index=0&id=5545c570&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5545c570",
  null
  
)

export default component.exports